export default __webpack_public_path__ + "static/media/GTD_adobespark.440678da.png";